export default __webpack_public_path__ + "static/media/loading-bee01@4x.56f992d2.jpeg";